import React, { createContext, useState, ReactNode, useCallback } from 'react';

interface ContactContextType {
  isOpen: boolean;
  pageContext: string;
  openModal: () => void;
  openModalWithContext: (context: string) => void;
  closeModal: () => void;
}

// Valeurs par défaut pour le contexte
const defaultContextValue: ContactContextType = {
  isOpen: false,
  pageContext: '',
  openModal: () => console.log('openModal non implémenté'),
  openModalWithContext: () => console.log('openModalWithContext non implémenté'),
  closeModal: () => console.log('closeModal non implémenté'),
};

export const ContactContext = createContext<ContactContextType>(defaultContextValue);

interface ContactProviderProps {
  children: ReactNode;
}

export const ContactProvider: React.FC<ContactProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [pageContext, setPageContext] = useState('');

  // Utilisation de useCallback pour éviter des re-renders inutiles
  const openModal = useCallback(() => {
    console.log('Modal ouverte');
    setPageContext(''); // Réinitialise le contexte si on ouvre sans préciser
    setIsOpen(true);
  }, []);
  
  const openModalWithContext = useCallback((context: string) => {
    console.log(`Modal ouverte depuis: ${context}`);
    setPageContext(context);
    setIsOpen(true);
  }, []);
  
  const closeModal = useCallback(() => {
    console.log('Modal fermée');
    setIsOpen(false);
  }, []);

  const contextValue = React.useMemo(() => ({
    isOpen,
    pageContext,
    openModal,
    openModalWithContext,
    closeModal
  }), [isOpen, pageContext, openModal, openModalWithContext, closeModal]);

  return (
    <ContactContext.Provider value={contextValue}>
      {children}
    </ContactContext.Provider>
  );
};